import { configureStore } from '@reduxjs/toolkit';
import appState from 'app/store/app-state.slice';

/**
 * @typedef {Object} AppState
 *
 * @property {string} appState.email - The user email
 * @property {string} appState.googleIdToken - The user google-sso jwt token response
 * @property {boolean} appState.isRegularSignUp - Go with regular sign up flow
 * @property {boolean} appState.isGoogleSignUp - Go with the Google sign up flow
 * @property {string} appState.link - easy-login for web
 * @property {string} appState.mobileLink - easy-login for mobile app
 */

const store = configureStore({
  reducer: {
    appState,
  },
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
